export const OPERATOR_PAGE_SECTIONS = [
    {
        title: "Panoramica",
        items: [
            { key: "/", label: "Dashboard" },
            { key: "/scadenze", label: "Scadenze" },
            { key: "/conformita", label: "Conformità HR" },
            { key: "/impostazioni/consegna", label: "Consegna telematica" },
            { key: "/registro-email", label: "Registro Email" },
        ],
    },
    {
        title: "Personale",
        items: [
            { key: "/dipendenti", label: "Dipendenti" },
            { key: "/personale/verifica-date", label: "Verifica date assunzione" },
            { key: "/gruppi", label: "Gruppi" },
            { key: "/notifiche/modifiche-dati", label: "Richieste modifiche dati" },
            { key: "/dipendenti/attivita", label: "Registro attività" },
            { key: "action:migration", label: "Migrazione" },
            { key: "action:import", label: "Importa Excel" },
        ],
    },
    {
        title: "Documenti",
        items: [
            { key: "/documenti/archivio", label: "Archivio" },
            { key: "/documenti/registro-consegne", label: "Registro consegne" },
            { key: "/documenti/in-attesa", label: "Upload massivo" },
            { key: "/documenti/da-firmare", label: "Da firmare" },
            { key: "/documenti/dipendenti", label: "Da dipendenti" },
            { key: "/documenti/mancanti", label: "Documenti mancanti" },
            { key: "/documenti/contratti", label: "Contratti" },
            { key: "/documenti/autodichiarazioni", label: "Autodichiarazione emolumenti" },
            { key: "/documenti/buste-paga", label: "Controllo buste paga" },
            { key: "/documenti/benvenuto", label: "Documenti benvenuto" },
            { key: "/modelli-contratto", label: "Modelli contratto" },
            { key: "/unilav", label: "UNILAV massivo" },
            { key: "/documenti/storico", label: "Storico operazioni" },
            { key: "/migrazione/stato", label: "Stato import" },
        ],
    },
    {
        title: "Tesserini",
        items: [
            { key: "/foto/upload", label: "Upload Fototessere" },
            { key: "action:print-a4", label: "Stampa A4" },
            { key: "action:export-a4", label: "Esporta A4" },
            { key: "/storico-stampe", label: "Storico stampe" },
            { key: "action:settings", label: "Impostazioni tesserini" },
        ],
    },
    {
        title: "Acconti",
        items: [
            { key: "/acconti", label: "Acconti dipendenti" },
            { key: "/acconti/tfr", label: "Fondo TFR (riservato)" },
            { key: "/acconti/fng", label: "F.N.G. Ferie non godute (riservato)" },
        ],
    },
    {
        title: "Presenze",
        items: [
            { key: "/presenze", label: "Timbrature" },
            { key: "/presenze/cantieri", label: "Cantieri" },
            { key: "/presenze/assegnazioni", label: "Assegnazioni" },
            { key: "/presenze/pianificazione", label: "Pianificazione" },
            { key: "/presenze/calendario", label: "Calendario presenze" },
        ],
    },
];

export const OPERATOR_PAGES = OPERATOR_PAGE_SECTIONS.flatMap((s) => s.items);

const ROUTE_KEYS = OPERATOR_PAGES.map((p) => p.key).filter((k) => k.startsWith("/"));

export const isPageAllowed = (user, pathname) => {
    if (!user) return false;
    if (user.role === "admin") return true;
    const pages = user.operator_pages || [];
    if (pathname === "/") return pages.includes("/");
    const match = ROUTE_KEYS
        .filter((k) => k !== "/" && (pathname === k || pathname.startsWith(k + "/")))
        .sort((a, b) => b.length - a.length)[0];
    return match ? pages.includes(match) : false;
};
